module.exports = __webpack_public_path__ + "static/media/local-central.7a1b9130.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central.png
// module id = 1177
// module chunks = 2